import { useRef } from "react";

/**
 * MagneticButton — a wrapper span that subtly attracts to the cursor.
 * Wraps a button or link. Uses transform on inner span so external styles remain intact.
 */
export default function MagneticButton({ children, strength = 5, className = "", ...rest }) {
  const innerRef = useRef(null);

  const onMove = (e) => {
    const el = innerRef.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const x = (e.clientX - rect.left - rect.width / 2) / (rect.width / 2);
    const y = (e.clientY - rect.top - rect.height / 2) / (rect.height / 2);
    el.style.transform = `translate(${x * strength}px, ${y * strength}px)`;
  };

  const onLeave = () => {
    const el = innerRef.current;
    if (el) el.style.transform = "translate(0px, 0px)";
  };

  // Snap back to zero immediately on mousedown so the click lands on the button
  // exactly where the user sees it — prevents "missed click" feel.
  const onDown = () => {
    const el = innerRef.current;
    if (el) el.style.transform = "translate(0px, 0px)";
  };

  return (
    <span
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      onMouseDown={onDown}
      className={`inline-block ${className}`}
      {...rest}
    >
      <span
        ref={innerRef}
        style={{ display: "inline-block", transition: "transform 220ms cubic-bezier(0.22, 1, 0.36, 1)" }}
      >
        {children}
      </span>
    </span>
  );
}
